const { Badge } = require("antd")

const ReportStatus = ({ value }) => {
    switch (value) {
        case "บรรจุ":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)
        case "Permanent":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)
        case "เข้าทำงานปกติ":
            return (<Badge color="#12B76A" text={value} style={{ backgroundColor: "#ECFDF3", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#027A48" }} />)

        case "รอเริ่มงาน":
            return (<Badge color="#FFBF1A" text={value} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} />)
        case "Pending Start":
            return (<Badge color="#FFBF1A" text={value} style={{ backgroundColor: "#FFF8E0", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFBF1A" }} />)

        case "ทดลองงาน":
            return (<Badge color="#FFA726" text={value} style={{ backgroundColor: "#FFF5E9", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFA726" }} />)
        case "Probation":
            return (<Badge color="#FFA726" text={value} style={{ backgroundColor: "#FFF5E9", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFA726" }} />)
        case "เข้างานสาย/กลับก่อน":
            return (<Badge color="#FFA726" text={value} style={{ backgroundColor: "#FFF5E9", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#FFA726" }} />)

        case "พ้นสภาพ":
            return (<Badge color="#F15046" text={value} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)
        case "Resigned":
            return (<Badge color="#F15046" text={value} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)

        case "ขาดงาน":
            return (<Badge color="#F15046" text={value} style={{ backgroundColor: "#FFF2EA", borderRadius: "16px", padding: "2px 8px", fontSize: "0.5vw", color: "#F15046" }} />)

        case "ลาป่วย":
            return <Badge color="#667085" text={value} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />
        default:
            return (<Badge color="#667085" text={value} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} />)
    }
}

export default ReportStatus;